import React from "react";
import { FaInstagram, FaXTwitter } from "react-icons/fa6";
import { FaFacebook, FaYoutube } from "react-icons/fa";
import { MdEmail, MdCall, MdLocationOn, MdOpacity } from "react-icons/md";
import mapBackground from "../images/mapcontainerbackground.png";
import mapUpside from "../images/mapupside.png";
import logo from "../images/logo.png";
import mapPageBackground from "../images/MapPageBackground.png";

export default function MapPage() {
  return (
    <>
      <style>
        {`
          @media (min-width: 320px) and (max-width: 480px) {
            .map-wrapper {
              padding: 35px 12px !important;
              min-height: 100vh !important;
            }
            
            .map-heading {
              font-size: 22px !important;
              margin-bottom: 25px !important;
              line-height: 1.3 !important;
              padding: 0 5px !important;
            }
            
            .map-contact-card {
              max-width: 100% !important;
              padding: 22px 18px !important;
              border-radius: 12px !important;
              min-height: 420px !important;
              margin: 0 8px !important;
            }
            
            .map-contact-title {
              font-size: 16px !important;
              margin-bottom: 14px !important;
            }
            
            .map-contact-item {
              font-size: 13px !important;
              margin: 7px 0 !important;
              line-height: 1.4 !important;
              word-break: break-word !important;
            }
            
            .map-contact-info {
              margin-bottom: 22px !important;
            }
            
            .map-social-row {
              padding: 7px 13px !important;
              gap: 12px !important;
              font-size: 14px !important;
              bottom: 12px !important;
              border-radius: 25px !important;
            }
            
            .map-logo {
              width: 55px !important;
              height: 55px !important;
              top: 180px !important;
              right: 12px !important;
            }
            
            .map-container {
              border-radius: 12px !important;
            }
            
            .map-image {
              border-radius: 12px !important;
            }
            
            .map-card-bg {
              border-radius: 12px !important;
            }
          }
          
          @media (max-width: 360px) {
            .map-wrapper {
              padding: 30px 8px !important;
            }
            
            .map-heading {
              font-size: 20px !important;
              margin-bottom: 20px !important;
              padding: 0 3px !important;
            }
            
            .map-contact-card {
              padding: 20px 15px !important;
              border-radius: 10px !important;
              min-height: 380px !important;
              margin: 0 5px !important;
            }
            
            .map-contact-title {
              font-size: 15px !important;
              margin-bottom: 12px !important;
            }
            
            .map-contact-item {
              font-size: 12px !important;
              margin: 6px 0 !important;
            }
            
            .map-contact-info {
              margin-bottom: 20px !important;
            }
            
            .map-social-row {
              padding: 6px 11px !important;
              gap: 10px !important;
              font-size: 13px !important;
              bottom: 10px !important;
              border-radius: 20px !important;
            }
            
            .map-logo {
              width: 50px !important;
              height: 50px !important;
              top: 160px !important;
              right: 10px !important;
            }
            
            .map-container {
              border-radius: 10px !important;
            }
            
            .map-image {
              border-radius: 10px !important;
            }
            
            .map-card-bg {
              border-radius: 10px !important;
            }
          }
        `}
      </style>
      <div style={styles.wrapper} className="map-wrapper">
      <h2 style={styles.heading} className="map-heading">
        We’re welcome you to <span style={styles.highlight}>join us!</span>
      </h2>

      <div style={styles.contactCard} className="map-contact-card">
        {/* Background with opacity */}
        <div style={styles.contactCardBackground} className="map-card-bg"></div>
        
        {/* Map upside image overlay */}
        <div style={styles.mapUpsideContainer} className="map-container">
          <img 
            src={mapUpside} 
            alt="Map Upside" 
            style={styles.mapUpsideImage}
            className="map-image"
            onClick={() => window.open('https://www.google.com/maps/search/future+fitness+nellore/@14.4319758,79.9673099,14z/data=!3m1!4b1?', '_blank')}
          />
        </div>

        <h3 style={styles.contactTitle} className="map-contact-title">Contact</h3>
 

        <div style={styles.contactInfo} className="map-contact-info">
          <p style={styles.contactItem} className="map-contact-item">
            <MdEmail style={styles.icon} /> FUTUREFITNESS@FITNESS.COM
          </p>
          <p style={styles.contactItem} className="map-contact-item">
            <MdCall style={styles.icon} /> +91 9640620404
          </p>
          <p style={styles.contactItem} className="map-contact-item">
            <MdLocationOn style={styles.icon} /> Current Office Center, Nellore
          </p>
        </div>

        <div style={styles.socialRow} className="map-social-row">
          <div 
            style={styles.socialIcon}
            onClick={() => window.open('https://www.instagram.com/futurefitness_gym_nellore/', '_blank')}
          >
            <FaInstagram />
          </div>
          <div 
            style={styles.socialIcon}
            onClick={() => window.open('https://www.facebook.com/FutureFitnessGYMNellore/', '_blank')}
          >
            <FaFacebook />
          </div>
          <div 
            style={styles.socialIcon}
            onClick={() => window.open('https://x.com/futurefitnessg1', '_blank')}
          >
            <FaXTwitter />
          </div>
          <div 
            style={styles.socialIcon}
            onClick={() => window.open('https://www.youtube.com/c/FUTUREFITNESSGYM/', '_blank')}
          >
            <FaYoutube />
          </div>
        </div>

        <img src={logo} alt="Logo" style={styles.logoBottom} className="map-logo" />
      </div>
    </div>
    </>
  );
}

const styles = {
  wrapper: {
    backgroundColor: '#1E1E1E', // Your page background
    backgroundImage: `url(${mapPageBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    color: '#fff',
    textAlign: 'center',
    padding: '60px 20px',
    fontFamily: 'Inter, sans-serif',
    minHeight: '100vh',
  },
  heading: {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '40px',
    wordWrap: 'break-word',
  },
  highlight: {
    color: '#39d353',
  },
  contactCard: {
    position: 'relative',
    borderRadius: '20px',
    padding: '40px',
    maxWidth: '800px',
    margin: '0 auto',
    display: 'flex',
    flexDirection: 'column',
    minHeight: '500px',
    overflow: 'hidden',
    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.6), 0 8px 16px rgba(0, 0, 0, 0.4)',
  },
  contactCardBackground: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: `url(${mapBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    opacity: 0.6,
    borderRadius: '20px',
    zIndex: 1,
  },
  contactTitle: {
    textAlign: 'left',
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '20px',
    position: 'relative',
    zIndex: 3,
  },
  contactInfo: {
    textAlign: 'left',
    marginBottom: '30px',
    position: 'relative',
    zIndex: 3,
  },
  contactItem: {
    fontSize: '20px',
    fontWeight: 'bold',
    margin: '10px 0',
    wordWrap: 'break-word',
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  icon: {
    color: '#39d353',
    marginRight: '10px',
    verticalAlign: 'middle',
    flexShrink: 0,
  },
  socialRow: {
    background: '#fff',
    borderRadius: '40px',
    display: 'inline-flex',
    gap: '20px',
    padding: '10px 20px',
    color: '#000',
    fontSize: '18px',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 3,
  },
  socialIcon: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease, color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  logoBottom: {
    position: 'absolute',
    top: '250px',
    right: '20px',
    width: '90px',
    height: '90px',
    objectFit: 'contain',
    zIndex: 3,
  },
  mapUpsideContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    height: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    zIndex: 2,
  },
  mapUpsideImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: '20px',
    cursor: 'pointer',
    transition: 'transform 0.2s ease',
  },
};
